import useApiController from "@hooks/useApiController"

export default function useSalonEbookController(salonId: string | number): Admin.Controllers.SalonEbook {
    const controller = useApiController(`/api/admin/salons/${salonId}/ebook`)

    const store = async (file: File) => {
        const formData = new FormData()
        formData.append('file', file)
        await controller.store(formData)
    }

    return {
        store
    }
}